import { render, staticRenderFns } from "./PromoCodeGeofence.vue?vue&type=template&id=38b0b6e6&"
import script from "./PromoCodeGeofence.vue?vue&type=script&lang=js&"
export * from "./PromoCodeGeofence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports